import {FiX as XIcon} from 'react-icons/fi';
import {BaseMark, BaseMarkProps} from './BaseMark';

type Props = Pick<BaseMarkProps, 'size' | 'shape'>;

export const XMark = ({size, shape}: Props) => (
  <BaseMark shape={shape} size={size} bgColor="#ED4D37" iconColor="#FFF" icon={<XIcon />} />
);
